import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Form, Table, Card } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Currency, {
  currencyReverse,
  CurrencyPlainText,
  CurrencyDollarPlainText,
  CurrencyEuroPlainText,
  EuroCurrency,
  DollarCurrency
} from 'helpers/Currency';

const ActionsFormFunds = ({
  planId,
  funds,
  setFunds,
  periodFunds,
  editable,
  position,
  totalFundsExpireValue,
  setTotalFundsExpireValue,
  currency
}) => {
  const [total, setTotal] = useState(0);
  const [use, setUse] = useState([]);
  const [flag, setFlag] = useState(true);

  useEffect(() => {
    var sum = 0;
    funds.forEach(
      (fund) =>{
        (sum += !!fund.value
          ? currencyReverse(fund.value)
          : 0);
      }
    );
    setTotal(sum);

    if(flag){
      let using = [];
      periodFunds.map((period_fund, k) => {
        if (typeof funds.filter(a=>a.fund_id === period_fund.id)[0] !== 'undefined') {
          using[k] = !!funds.filter(a=>a.fund_id === period_fund.id)[0].value
            ? currencyReverse(funds.filter(a=>a.fund_id === period_fund.id)[0].value)
            : 'R$ 0,00';
          if (funds.filter(a=>a.fund_id === period_fund.id)[0].value == 0 && editable === 0) {
            using[k] = 'R$ 0,00';
          }
          setFlag(false);
        }
      });
      setUse(using);
    }
  }, [funds, periodFunds]);

  const { t } = useTranslation();

  const handleChangeFund = (k, value, available, id) => {
    const updateArray = [...funds];

    let val = '';
    
    if(value.includes('R$') || value.includes('€')){
      val = parseFloat(
        value.replace('R$', '').replace('€', '').replace('.', '').replace(',', '.')
      );
    }
    else{
      val = parseFloat(
        value.replace('$', '').replace(',', '')
      );
    }

    if (val > available) {
      toast.error(t('error:funds greater than available'), {
        autoClose: 10000,
      });
      if(updateArray[k]){
        updateArray[k].value = 0;
        updateArray[k].fund_id = null;
        setFunds(updateArray);
      }
      return;
    } else {
      updateArray[k].value = value;
      updateArray[k].fund_id = id;
      setFunds(updateArray);
    }
  };

  const getCurrency = (using,k,available,id) => {
    switch(currency){
      case '1':
        return <Currency
        value={using}
        onChange={(e) =>
          handleChangeFund(k, e.target.value, available,id)
        }
        disabled={!editable}
      />;
        break;
      case '2':
        return <DollarCurrency
        value={using}
        onChange={(e) =>
          handleChangeFund(k, e.target.value, available,id)
        }
        disabled={!editable}
      />;
        break;
      case '3':
        return <EuroCurrency
        value={using}
        onChange={(e) =>
          handleChangeFund(k, e.target.value, available,id)
        }
        disabled={!editable}
      />;
        break;
      default:
        break;
    }
  }

  const getCurrencyText = (total) => {
    switch(currency){
      case '1':
        return <CurrencyPlainText value={total} />;
        break;
      case '2':
        return <CurrencyDollarPlainText value={total} />;;
        break;
      case '3':
        return <CurrencyEuroPlainText value={total} />;;
        break;
      default:
        break;
    }
  }

  return (
    <>
      <Row>
        <Col>
          <Row className="mb-2">
            <Col>
              <h5>{t('title:fund')}</h5>
            </Col>
          </Row>
          {/* <Table bordered hover responsive> */}          
          <div className="table-responsive">
            <table className="table table-bordered table-hover">
              <thead>
                <tr>
                  <th className="text-center align-middle">{t('label:type')}</th>
                  <th className="text-center align-middle">Valor da Cotação</th>
                  {/* {parseInt(position) <= 30 && ( */}
                    <>
                      <th className="text-center align-middle">
                        {t('label:added')}
                      </th>
                      <th className="text-center align-middle">
                        {t('label:added') + ' (R$)'}
                      </th>
                      <th className="text-center align-middle">
                        {t('label:used')}
                      </th>
                      <th className="text-center align-middle">
                        {t('label:action expire value')}</th>
                      <th className="text-center align-middle">
                        {t('label:available')}
                      </th>
                    </>
                  <th className="text-center align-middle">
                    {t('label:action value')}
                  </th>
                </tr>
              </thead>
              <tbody>
                {periodFunds.map((period_fund, k) => {
                  let using = '0';
                  let expireValue = 0;
                  const added = parseFloat(period_fund.value);
                  const addedOtherCurrency = parseFloat(
                    period_fund.value
                  );

                  if (typeof funds.filter(a=>a.fund_id === period_fund.id)[0] !== 'undefined') {
                    using = !!funds.filter(a=>a.fund_id === period_fund.id)[0].value
                      ? currencyReverse(funds.filter(a=>a.fund_id === period_fund.id)[0].value)
                      : 'R$ 0,00';
                    if (funds.filter(a=>a.fund_id === period_fund.id)[0].value == 0 && editable === 0) {
                      using = 'R$ 0,00';
                    }
                  }

                  const used = parseFloat(period_fund.used);

                  if (
                    typeof period_fund.total_funds_expire_value !== 'undefined'
                  ) {
                    expireValue += parseFloat(
                      period_fund.total_funds_expire_value
                    );
                    setTotalFundsExpireValue(expireValue);
                  }

                  const available =
                    addedOtherCurrency - used - totalFundsExpireValue + (editable && use[k] !== undefined ? use[k] : 0);
                  return (
                    <tr key={k}>
                      <td className="text-center align-middle pt-4">
                        {t(`label:${period_fund.type.name}`)}
                      </td>
                      <td className="text-center align-middle pt-4">
                      {period_fund.value_cotacao?'R$ '+period_fund.value_cotacao.replace('.',','):'--'}
                      </td>
                      {/* {parseInt(position) <= 30 && (
                        <> */}
                          <td className="text-center align-middle pt-4">
                            {period_fund.type.currency_id === 3 ? (
                              <CurrencyEuroPlainText value={added} />
                            ) : period_fund.type.currency_id === 2 ? (
                              <CurrencyDollarPlainText value={added} />
                            ) : (
                              <CurrencyPlainText value={added} />
                            )}
                          </td>
                          <td className="text-center align-middle pt-4">
                            <CurrencyPlainText value={parseFloat(period_fund.value_currency)} />
                          </td>
                          <td className="text-center align-middle pt-4">
                          {getCurrencyText(used)}
                            {/* <CurrencyPlainText value={used} /> */}
                          </td>
                          <td className="text-center align-middle pt-4">
                          {getCurrencyText(totalFundsExpireValue)}
                            {/* <CurrencyPlainText value={totalFundsExpireValue} /> */}
                          </td>
                          <td className="text-center align-middle pt-4">
                          {getCurrencyText(available)}
                            {/* <CurrencyPlainText value={available} /> */}
                          </td>
                        {/* </>
                      )} */}
                      <td className="text-center align-middle">
                        {/* <Currency
                          value={using}
                          onChange={(e) =>
                            handleChangeFund(k, e.target.value, available)
                          }
                          disabled={!editable}
                        /> */}
                        {getCurrency(using,k,available,period_fund.id)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {/* </Table> */}
          <Row>
            <Col md={5}>
              <Form.Group as={Row}>
                <Form.Label className="font-weight-bold" column sm={2} xl={3}>
                  {t('label:total')}:
                </Form.Label>
                <Form.Text sm={5}>
                  {/* <CurrencyPlainText value={total} /> */}
                  {getCurrencyText(total)}
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default ActionsFormFunds;
